import React, { useState } from "react";
import "./FerfarForm.css";

const FerfarList = () => {
  const [filters, setFilters] = useState({
    ward: "",
    propertyNo: "",
    ownerName: "",
  });

  const records = [
    {
      id: 1,
      date: "15-01-2026",
      propertyNo: "101",
      reason: "हस्तांतर",
      currentOwner: "राज शर्मा",
      occupier: "राज शर्मा",
      newOwner: "प्रिया शर्मा",
      heir: "अनिल शर्मा",
    },
    {
      id: 2,
      date: "20-01-2026",
      propertyNo: "102",
      reason: "वारसा",
      currentOwner: "अभी लांबे",
      occupier: "अभी लांबे",
      newOwner: "विजय लांबे",
      heir: "संजय लांबे",
    },
  ];

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSearch = () => {
    console.log("Search Filters:", filters);
  };

  const handleReset = () => {
    setFilters({ ward: "", propertyNo: "", ownerName: "" });
  };

  const filteredRecords = records.filter((r) => {
    return (
      (filters.ward === "" || r.propertyNo.includes(filters.ward)) &&
      (filters.propertyNo === "" ||
        r.propertyNo.includes(filters.propertyNo)) &&
      (filters.ownerName === "" ||
        r.currentOwner.toLowerCase().includes(filters.ownerName.toLowerCase()))
    );
  });

  return (
    <div className="ferfar-list-container">
      <h3 className="ferfar-title">📋 फेरफार नमुना नं ८ यादी</h3>

      {/* FILTER SECTION */}
      <div className="ferfar-filter-section">
        <input
          name="ward"
          placeholder="वॉर्डचे नाव"
          value={filters.ward}
          onChange={handleChange}
          className="ferfar-input"
        />

        <input
          name="propertyNo"
          placeholder="मालमत्ता क्र."
          value={filters.propertyNo}
          onChange={handleChange}
          className="ferfar-input"
        />

        <input
          name="ownerName"
          placeholder="मालकाचे नाव"
          value={filters.ownerName}
          onChange={handleChange}
          className="ferfar-input"
        />

        <button onClick={handleSearch} className="ferfar-btn-search">
          🔍 शोधा
        </button>
        <button onClick={handleReset} className="ferfar-btn-reset">
          🔄 यादी
        </button>
      </div>

      {/* TABLE */}
      <div className="ferfar-table-wrapper">
        <table className="ferfar-table">
          <thead>
            <tr>
              <th>क्र.</th>
              <th>फेरफार दिनांक</th>
              <th>मालमत्ता क्र.</th>
              <th>फेरफार कारण</th>
              <th>सध्य मालकाचे नाव</th>
              <th>भोगवटाधारकाचे नाव</th>
              <th>नवीन मालकाचे नाव</th>
              <th>वारसाचे नाव</th>
            </tr>
          </thead>

          <tbody>
            {filteredRecords.length === 0 ? (
              <tr>
                <td colSpan="8" className="ferfar-no-data">
                  📭 कोणत्याही रेकॉर्ड नाहीत
                </td>
              </tr>
            ) : (
              filteredRecords.map((r, i) => (
                <tr key={r.id}>
                  <td>{i + 1}</td>
                  <td>{r.date}</td>
                  <td>{r.propertyNo}</td>
                  <td>{r.reason}</td>
                  <td>{r.currentOwner}</td>
                  <td>{r.occupier}</td>
                  <td>{r.newOwner}</td>
                  <td>{r.heir}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const FerfarForm = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    propertyNo: "",
    ferfarDate: "",
    reason: "",
    currentOwner: "",
    newOwner: "",
    heir: "",
    occupier: "",
  });

  const [records, setRecords] = useState([
    {
      id: 1,
      date: "15-01-2026",
      propertyNo: "101",
      reason: "हस्तांतर",
      currentOwner: "राज शर्मा",
      occupier: "राज शर्मा",
      newOwner: "प्रिया शर्मा",
      heir: "अनिल शर्मा",
    },
    {
      id: 2,
      date: "20-01-2026",
      propertyNo: "102",
      reason: "वारसा",
      currentOwner: "अभी लांबे",
      occupier: "अभी लांबे",
      newOwner: "विजय लांबे",
      heir: "संजय लांबे",
    },
  ]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (
      !formData.propertyNo ||
      !formData.ferfarDate ||
      !formData.reason ||
      !formData.currentOwner ||
      !formData.newOwner
    ) {
      alert("कृपया सर्व आवश्यक फील्ड भरा!");
      return;
    }

    const newRecord = {
      id: records.length + 1,
      date: formData.ferfarDate,
      propertyNo: formData.propertyNo,
      reason: formData.reason,
      currentOwner: formData.currentOwner,
      occupier: formData.occupier || formData.currentOwner,
      newOwner: formData.newOwner,
      heir: formData.heir || "---",
    };

    setRecords([...records, newRecord]);
    alert("✅ फेरफार नोंद यशस्वीरित्या जतन झाली!");

    setFormData({
      propertyNo: "",
      ferfarDate: "",
      reason: "",
      currentOwner: "",
      newOwner: "",
      heir: "",
      occupier: "",
    });
    setShowForm(false);
  };

  const handleReset = () => {
    setFormData({
      propertyNo: "",
      ferfarDate: "",
      reason: "",
      currentOwner: "",
      newOwner: "",
      heir: "",
      occupier: "",
    });
  };

  return (
    <div className="ferfar-form-container">
      <div className="ferfar-form-header">
        <h3>📝 नवीन फेरफार नमुना नं ८</h3>
        <button
          className="ferfar-btn-toggle"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? "✕ बंद करा" : "➕ नवीन फेरफार"}
        </button>
      </div>

      {showForm && (
        <div className="ferfar-form-content">
          <div className="ferfar-form-grid">
            <div className="ferfar-field">
              <label>मालमत्ता क्र. <span className="ferfar-required">*</span></label>
              <input
                name="propertyNo"
                placeholder="मालमत्ता क्र."
                value={formData.propertyNo}
                onChange={handleChange}
                className="ferfar-input-field"
              />
            </div>

            <div className="ferfar-field">
              <label>फेरफार दिनांक <span className="ferfar-required">*</span></label>
              <input
                type="date"
                name="ferfarDate"
                value={formData.ferfarDate}
                onChange={handleChange}
                className="ferfar-input-field"
              />
            </div>

            <div className="ferfar-field">
              <label>फेरफार कारण <span className="ferfar-required">*</span></label>
              <select
                name="reason"
                value={formData.reason}
                onChange={handleChange}
                className="ferfar-input-field"
              >
                <option value="">-- निवडा --</option>
                <option value="हस्तांतर">हस्तांतर</option>
                <option value="वारसा">वारसा</option>
                <option value="भाग विभाजन">भाग विभाजन</option>
                <option value="गिरवी">गिरवी</option>
                <option value="इतर">इतर</option>
              </select>
            </div>

            <div className="ferfar-field">
              <label>सध्य मालकाचे नाव <span className="ferfar-required">*</span></label>
              <input
                name="currentOwner"
                placeholder="सध्य मालकाचे नाव"
                value={formData.currentOwner}
                onChange={handleChange}
                className="ferfar-input-field"
              />
            </div>

            <div className="ferfar-field">
              <label>भोगवटाधारकाचे नाव</label>
              <input
                name="occupier"
                placeholder="भोगवटाधारकाचे नाव"
                value={formData.occupier}
                onChange={handleChange}
                className="ferfar-input-field"
              />
            </div>

            <div className="ferfar-field">
              <label>नवीन मालकाचे नाव <span className="ferfar-required">*</span></label>
              <input
                name="newOwner"
                placeholder="नवीन मालकाचे नाव"
                value={formData.newOwner}
                onChange={handleChange}
                className="ferfar-input-field"
              />
            </div>

            <div className="ferfar-field">
              <label>वारसाचे नाव</label>
              <input
                name="heir"
                placeholder="वारसाचे नाव"
                value={formData.heir}
                onChange={handleChange}
                className="ferfar-input-field"
              />
            </div>
          </div>

          <div className="ferfar-form-actions">
            <button onClick={handleSubmit} className="ferfar-btn-save">
              💾 जतन करा
            </button>
            <button onClick={handleReset} className="ferfar-btn-cancel">
              🔄 रीसेट करा
            </button>
          </div>
        </div>
      )}

      {/* FORM LIST */}
      <div className="ferfar-records-section">
        <h4 className="ferfar-records-title">📊 नोंदीकृत फेरफार</h4>
        <div className="ferfar-table-wrapper">
          <table className="ferfar-table">
            <thead>
              <tr>
                <th>क्र.</th>
                <th>दिनांक</th>
                <th>मालमत्ता क्र.</th>
                <th>कारण</th>
                <th>वर्तमान मालक</th>
                <th>नवीन मालक</th>
                <th>वारसा</th>
              </tr>
            </thead>
            <tbody>
              {records.length === 0 ? (
                <tr>
                  <td colSpan="7" className="ferfar-no-data">
                    📭 कोणत्याही नोंद नाहीत
                  </td>
                </tr>
              ) : (
                records.map((r, i) => (
                  <tr key={r.id}>
                    <td>{i + 1}</td>
                    <td>{r.date}</td>
                    <td>{r.propertyNo}</td>
                    <td>{r.reason}</td>
                    <td>{r.currentOwner}</td>
                    <td>{r.newOwner}</td>
                    <td>{r.heir}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export { FerfarList, FerfarForm };
export default FerfarForm;
